import { useLayoutEffect } from 'react';

const scrollViewportToTop = () => {
  if (typeof window === 'undefined') {
    return;
  }

  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

/**
 * Hook personalizado para hacer scroll al inicio de la página
 * Se ejecuta automáticamente cuando el componente se monta
 */
export const useScrollToTop = () => {
  useLayoutEffect(() => {
    scrollViewportToTop();

    const rafId = window.requestAnimationFrame(() => {
      scrollViewportToTop();
    });

    return () => {
      window.cancelAnimationFrame(rafId);
    };
  }, []);
};

/**
 * Hook personalizado para hacer scroll al inicio con dependencias
 * Útil cuando quieres controlar cuándo hacer scroll
 */
export const useScrollToTopWithDeps = (dependencies: any[] = []) => {
  useLayoutEffect(() => {
    scrollViewportToTop();

    const rafId = window.requestAnimationFrame(() => {
      scrollViewportToTop();
    });

    return () => {
      window.cancelAnimationFrame(rafId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

/**
 * Función utilitaria para hacer scroll al inicio
 * Útil para llamar manualmente desde botones o eventos
 */
export const scrollToTop = () => {
  scrollViewportToTop();
};
